import { useEffect } from "react";

const SITE_URL = "https://atheriam.com";
const DEFAULT_IMAGE = `${SITE_URL}/og-image.png`;

function setMeta(attr, key, value) {
  if (!value) return;
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", value);
}

function setCanonical(href) {
  let el = document.head.querySelector('link[rel="canonical"]');
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", "canonical");
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
}

/**
 * Updates document title + social meta for the current route.
 */
const SeoHead = ({
  title,
  description,
  path = "/",
  image = DEFAULT_IMAGE,
  type = "website",
}) => {
  useEffect(() => {
    const fullTitle = title.includes("Atheriam")
      ? title
      : `${title} | Atheriam`;
    const url = `${SITE_URL}${path.startsWith("/") ? path : `/${path}`}`;

    document.title = fullTitle;
    setCanonical(url);

    setMeta("name", "title", fullTitle);
    setMeta("name", "description", description);

    setMeta("property", "og:type", type);
    setMeta("property", "og:url", url);
    setMeta("property", "og:title", fullTitle);
    setMeta("property", "og:description", description);
    setMeta("property", "og:image", image);
    setMeta("property", "og:site_name", "Atheriam");

    setMeta("name", "twitter:card", "summary_large_image");
    setMeta("name", "twitter:url", url);
    setMeta("name", "twitter:title", fullTitle);
    setMeta("name", "twitter:description", description);
    setMeta("name", "twitter:image", image);
    setMeta("name", "twitter:site", "@AtheriamEco");
  }, [title, description, path, image, type]);

  return null;
};

export default SeoHead;
